import { makeStyles } from '@material-ui/core/styles';

export const useTextFieldStyles = makeStyles(theme => ({
	root: {
		width: '100%',
		'& label.Mui-focused': {
			color: theme.palette.secondary.main
		},
		'& .MuiInput-underline:after': {
			borderBottomColor: theme.palette.secondary.main
		},
		fontSize: theme.typography.body2.fontSize
		/* '& label': {
            paddingLeft: 8,
        },
        '& .MuiFilledInput-root': {
            backgroundColor: COLORS.BACKGROUND_GREY_LIGHT,
        },
        '& .MuiFilledInput-input': {
            paddingLeft: 20,
        },
        '& .MuiFilledInput-underline': {
            '&:before,&:after': {
                borderBottom: 0,
            },
        },
        '& .MuiFormHelperText-contained': {
            marginLeft: theme.spacing(1.5),
            marginRight: theme.spacing(1.5),
            marginBottom: theme.spacing(0.5),
            fontSize: '0.688rem',
        }, */
		/* '& label.Mui-focused': {
            color: theme.palette.secondary.main,
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: theme.palette.secondary.main,
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: COLORS.BORDER_BUTTON_DEFAULT,
            },
            '&:hover:not(.Mui-focused) fieldset': {
                borderColor: theme.palette.secondary.main,
            },
            '&.Mui-focused fieldset': {
                borderColor: theme.palette.secondary.main,
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: '15px 12px',
        },
        '& .MuiFormHelperText-contained': {
            marginLeft: theme.spacing(1.5),
            marginRight: theme.spacing(1.5),
            fontSize: '0.688rem',
        }, */
	}
}));
